import { render } from "./Tims.vue?vue&type=template&id=9e72df20"
import script from "./Tims.vue?vue&type=script&lang=js"
export * from "./Tims.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__